import script from "./ProfilesNav.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilesNav.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__